import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { TARM_AWS_URL } from '../../api/api';
import axios from 'axios';
import { Code, Heading, VStack, useToast } from '@chakra-ui/react';
import Loading from '../Loading/Loading';
import DetailedViewTab from './DetailedViewTabs.js/DetailedViewTab';

const GenAIJsonView = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [genAIJson, setGenAIJson] = useState(null)
  const { filename } = useParams();
  console.log(filename)
  const [source] = useState(axios.CancelToken.source());
  const toast = useToast();

  useEffect(() => {
    getGenAIJson(filename);
    return () => {
    };
  }, []);


  const getGenAIJson = async (filename) => {
    try {
      const response = await TARM_AWS_URL.get(
        'get-gen-ai-json', { params: { filename: filename } },
        {
          cancelToken: source.token,
        }
      );
      console.log(response);
      setGenAIJson(response.data)
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    isLoading ? (
      <Loading loading={isLoading} />
    ) : ((
      <VStack>
        <Heading>Detailed View</Heading>
        <br />
        {
          genAIJson && <DetailedViewTab genAIJson={genAIJson} />
        }
        <br />
      </VStack>
    )))
}

export default GenAIJsonView